
<template>
  <div class="detail">
    <p class="userInfo">基本经营信息</p>
    <table-manager :tableData="formData" :disable="true"></table-manager>
    <table-temp
      title="已发行产品"
      :flag="1"
      :tableData="publishData"
      :columnData="publishConf"
      :isEdit="true"
      :showSummary="true"
      :summaryMethod="getSummaries"
      :text="text"
      @editTable="editTable"
    ></table-temp>

    <table-temp
      title="拟发行产品"
      :flag="1"
      :tableData="inToPublishData"
      :columnData="inToPublishConf"
      :isEdit="false"
    ></table-temp>
    <table-temp
      title="企业重大变更事项"
      :flag="1"
      :tableData="updataData"
      :columnData="updataConf"
      :isEdit="false"
    ></table-temp>
    <div class="info">
      <p class="userInfo">信息表</p>
      <div class="downReport">
        <span class="downText">{{ reportName }}.doc</span>
        <el-button
          type="primary"
          plain
          class="download"
          @click="download"
          style="font-size: 14px"
          >下载</el-button
        >
      </div>
    </div>
    <detail-indialog
      :title="title"
      :dialogVisible="dialogVisible"
      :tableData="tableData"
      @closeDialog="closeDialog"
    ></detail-indialog>
  </div>
</template>

<script>
import TableTemp from "@table/table";
// import TableManager from "./components/AgencyTable";
import TableManager from "./components/managerTable";
import DetailIndialog from "./components/dialog/detailInDialog";
import { step2, step3, step4 } from "@/conf/Report-manager";

import { getReportDetail, downloadInfo, getProduct } from "common/js/api";

export default {
  components: {
    TableManager,
    TableTemp,
    DetailIndialog,
  },

  data() {
    return {
      formData: {},
      codeId: this.$route.query.codeId,
      // 已发行
      publishData: [],
      publishConf: step2,
      // 拟发行
      inToPublishData: [{ id: 1 }],
      inToPublishConf: step3,
      //变更事项
      updataData: [],
      updataConf: step4,
      reportName: "",
      text: "查看项目",
      title: "已发行产品情况",
      dialogVisible: false,
      fundId: "",
      tableData: [],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    //获取已发行产品详细信息列表
    async getMessageList() {
      const { result } = await getProduct(this.fundId);
      this.tableData = result;
      this.tableData.map((item) => {
        item.investTime = item.investTime
          ? this.$moment(item.investTime).format("YYYY-MM-DD")
          : this.$moment(new Date()).format("YYYY-MM-DD");
        item.investOutTime = item.investOutTime
          ? this.$moment(item.investOutTime).format("YYYY-MM-DD")
          : this.$moment(new Date()).format("YYYY-MM-DD");
        item.p2p === true ? (item.p2p = "是") : (item.p2p = "否");
      });
    },
    //查看项目
    editTable(val) {
      this.fundId = val.scope.row.id;
      this.getMessageList();
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (column.property === "capitalAdmit") {
            return Number(item[column.property]);
          } else if (column.property === "capitalPaid") {
            return Number(item[column.property]);
          } else if (column.property === "capitalInvested") {
            return Number(item[column.property]);
          } else return;
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async getData() {
      const res = await getReportDetail(this.codeId);

      this.formData = res.result.basic;
      this.publishData = res.result["product-fund"];

      this.inToPublishData = res.result.preProduct;
      this.updataData = res.result.change;
      this.reportName = this.formData.quarterReportName;
    },

    async download() {
      await downloadInfo(this.codeId);
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 24px;
  color: #0f1824;
}
.downText {
  background: #eff1f5 !important;
  display: inline-block;
  width: 250px;
  height: 32px;
  vertical-align: bottom;
  text-align: center;
  line-height: 32px;
}
.downReport {
  margin-top: 20px;
}
</style>

